module.exports = __webpack_public_path__ + "bounceInTop.gif";